import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import cn from 'classnames';

import Button from '../Button';
import Footer from '../Footer';
import Header from '../Header';

import style from './ErrorFallback.module.scss';

export default function ErrorFallback({ resetErrorBoundary }) {
  const { t } = useTranslation();
  const location = useLocation();
  const isFirstRender = useRef(true);

  // Leave the error state after navigating to another page
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    resetErrorBoundary();
  }, [location.key]);

  return (
    <>
      <Header />
      <main>
        <section className={cn('sec tone-dark', style.container)}>
          <div className={cn('wrap', style.inner)}>
            <h1 className='h2'>{t('error.title')}</h1>
            <p className='lead'>{t('error.text')}</p>
            <Button
              to='/'
              size='lg'
              arrow
            >
              {t('notFound.button')}
            </Button>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
